import TrendingProducts from "../components/Products/TrendingProducts";
import SingleProduct from "../components/Products/SingleProduct";

const ProductPage = () => {
  return (
    <>
      <SingleProduct />
      <TrendingProducts />
    </>
  );
};

export default ProductPage;
